import { render, staticRenderFns } from "./AuthorizationTabs.vue?vue&type=template&id=2d76d452&scoped=true"
import script from "./AuthorizationTabs.vue?vue&type=script&lang=js"
export * from "./AuthorizationTabs.vue?vue&type=script&lang=js"
import style1 from "./AuthorizationTabs.vue?vue&type=style&index=1&id=2d76d452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76d452",
  null
  
)

export default component.exports